import { useTranslation } from "react-i18next";
import formatPrice from "@/core/helpers/formatPrice";
import { RubleIcon } from "@/shared/icons";
import { SoundButton, SoundModal } from "@/shared/ui";
import { FRIDGE_CONTAINER } from "@/domains/estate/constants/constants";

type Props = {
  capacity: number;
  price: number;
  onClose: () => void;
  onConfirm: () => void;
  isConfirming: boolean;
};

export default function EstateFridgeBuyImprovementModal({
  capacity,
  price,
  onClose,
  onConfirm,
  isConfirming,
}: Props) {
  const { t } = useTranslation("estate");

  return (
    <SoundModal
      open
      onClose={onClose}
      className="lightBlue2Shadow30 w-[25.125rem]"
      classNameOverlay="absolute"
      container={FRIDGE_CONTAINER}
      dataMzAccent="lightBlue2"
    >
      <div className="relative flex flex-col items-center">
        <div className="text-18 font-bold">{t("estate.fridge.buyingImprovement")}</div>
        <div className="h-[1px] w-[20rem] bg-[#1F1F1F]/80 flex justify-center my-5">
          <div className="h-full w-[5rem] bg-accent-solid" />
        </div>
        <div className="max-w-75 text-16 font-medium text-center">
          {t("estate.fridge.upCapacity")}
          <span className="ml-1 text-accent-solid font-bold">{capacity}</span> ?
        </div>
        <div className="flex justify-center items-center gap-2 w-full h-11 mt-3.5 mb-4 p-3.5 bg-gradient-to-b from-accent-solid/10 to-accent-muted/10 rounded-xl border border-dashed border-accent-solid">
          <p className="text-16 font-medium leading-none">
            <RubleIcon className="size-5.5 text-accent-solid" />
          </p>
          <p className="text-16 font-bold leading-none">{formatPrice(price)} ₽</p>
        </div>
        <div className="grid grid-cols-2 gap-2 w-full">
          <SoundButton className="w-full h-11" onClick={onClose} disabled={isConfirming}>
            {t("estate.fridge.cancel")}
          </SoundButton>
          <SoundButton
            className="w-full h-11"
            variant="solid-surface"
            onClick={onConfirm}
            loading={isConfirming}
            disabled={isConfirming}
          >
            {t("estate.fridge.yes")}
          </SoundButton>
        </div>
      </div>
    </SoundModal>
  );
}
